import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center bg-white">
      {/* Single subtle red accent - CSS-only for performance */}
      <div 
        className="absolute top-1/4 right-1/4 w-[300px] h-[300px] md:w-[600px] md:h-[600px] bg-[#cc0000] rounded-full blur-3xl opacity-[0.03]"
        aria-hidden="true"
      />

      <div className="container mx-auto px-4 sm:px-6 md:px-12 lg:px-32 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="max-w-5xl mx-auto text-center space-y-8 md:space-y-16"
        >
          {/* ICONIC HEADLINE - responsive text sizing, marked as LCP element */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-light tracking-tight text-neutral-900 leading-[1.1]">
            Welcome to August.
            <span className="text-[#cc0000] block mt-2 md:mt-4">Go Further.</span>
          </h1>

          <div className="pt-0">
            {/* CONCISE MANIFESTO PARAGRAPH - responsive text sizing */}
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-serif text-neutral-700 leading-relaxed max-w-4xl mx-auto pt-4 md:pt-6 px-2">
              Engineered Intelligence. We apply a rigorous, research-led methodology to build data architectures that drive measurable business growth.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
